module.exports = __webpack_public_path__ + "img/protect.5cd639c6.svg";